<ion-app>
    <usucampeao-menu></usucampeao-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
